import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DatePicker, RadioButton } from 'yankees-react-utils';

const DatePickerWrapper = styled.div`
    width: 130px;
    display: inline-block;
`;

const Header = ({ showMph, setShowMph, startDate, setStartDate, endDate, setEndDate }) => {
    const { t } = useTranslation();

    const [innerStartDate, setInnerStartDate] = useState(startDate);
    const [innerEndDate, setInnerEndDate] = useState(endDate);

    const onApply = () => {
        setStartDate(innerStartDate);
        setEndDate(innerEndDate);
    };

    return (
        <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">{ t('sections.post-game.home.in-game-speed') }</h3>
            <div className="d-flex align-items-center">
                <RadioButton label={t('sections.post-game.in-game-speed.mph')} id="mph" name="mph" onChange={() => setShowMph(true)} checked={showMph} />
                <RadioButton label={t('sections.post-game.in-game-speed.fts')} id="fts" name="fts" onChange={() => setShowMph(false)} checked={!showMph} />
                <div className="border py-2 px-3 rounded ms-3 bg-white">
                    <span>{t('common.start')}:&nbsp;</span>
                    <DatePickerWrapper>
                        <DatePicker value={innerStartDate} onSelect={setInnerStartDate} maxDate={innerEndDate} />
                    </DatePickerWrapper>
                    <span className="mx-2">{t('common.to')}</span>
                    <DatePickerWrapper>
                        <DatePicker value={innerEndDate} onSelect={setInnerEndDate} minDate={innerStartDate} />
                    </DatePickerWrapper>
                    <Button size="sm" className="ms-3" onClick={onApply}>{t('common.apply')}</Button>
                </div>
            </div>
        </div>
    );
};

export default Header;
